import { render, staticRenderFns } from "./RecoverPasswordModal.vue?vue&type=template&id=25e9bc84&scoped=true"
import script from "./RecoverPasswordModal.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./RecoverPasswordModal.vue?vue&type=style&index=0&id=25e9bc84&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e9bc84",
  null
  
)

export default component.exports